module.exports = __webpack_public_path__ + "static/img/cont3102.1b7f727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3102.jpg
// module id = GTos
// module chunks = 0